export default "__VITE_ASSET__656d088f__"